import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";

export const excusalFragment = {
  excusalDetails: gql`
    fragment excusalItem on AttendanceExcusal {
      id
      student {
        id
        firstName
        middleName
        lastName
        profileImage
        preferredName
        suffix
        pronouns
        sourceId
        isArchived
        isArchivedV2(filters: $studentArchivedFilters)
        courses {
          id
          title
        }
        alertTypes {
          ...alertTypeFields
        }
      }
      durationType
      startDate
      endDate
      reason
      attendanceOption {
        id
        label
        abbreviation
        color
        sendSMS
        attendanceCategory {
          id
          color
        }
      }
      periods {
        id
        label
        startTime
        endTime
        abbreviation
      }
      conversation {
        id
        unreadMessageCount
      }
    }
    ${studentsAlertFragment}
  `,
};
